import React, { useContext, useState, useEffect } from "react"
import i18n from "i18n"
import {
  Box,
  TextField,
  Grid,
  MenuItem,
  Typography,
  Autocomplete,
} from "@mui/material"
import PropTypes from "prop-types"
import { costTypes } from "../../constants"
import ContactField from "components/Contacts/ContactField"

const AccountingSection = ({ formData, handleInputChange }) => {
  const getAllocatedStatus = () => {
    const allocated = formData.allocated || 0
    const total = formData.total || 0

    if (allocated === 0 || total === 0) {
      return "no"
    }

    const percentage = allocated / total

    if (percentage >= 1) {
      return "yes"
    } else {
      return "partial"
    }
  }

  const allocatedStatus = getAllocatedStatus()

  return (
    <>
      <Grid item xs={12}>
        <Typography sx={{ mt: 2, fontWeight: "bold" }}>
          {i18n.t("costs.modal.accountingClassification")}
        </Typography>
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          fullWidth
          select
          required
          label={i18n.t("costs.columns.type")}
          value={formData.expense_type || costTypes[0]}
          onChange={handleInputChange("expense_type")}
          variant="outlined"
        >
          {costTypes.map(type => (
            <MenuItem key={type} value={type}>
              {i18n.t(`costs.types.${type}`)}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          fullWidth
          select
          required
          label={i18n.t("costs.columns.nature")}
          value={
            formData.is_direct === true
              ? "direct"
              : formData.is_direct === false
                ? "indirect"
                : ""
          }
          onChange={e =>
            handleInputChange("is_direct")({
              target: { value: e.target.value === "direct" },
            })
          }
          variant="outlined"
        >
          <MenuItem value="direct">{i18n.t("costs.nature.direct")}</MenuItem>
          <MenuItem value="indirect">
            {i18n.t("costs.nature.indirect")}
          </MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          fullWidth
          label={i18n.t("costs.columns.allocated")}
          value={i18n.t(`costs.allocated.${allocatedStatus}`)}
          variant="outlined"
          InputProps={{
            readOnly: true,
          }}
        />
      </Grid>
      <Grid item xs={12} md={3} sx={{ position: "relative" }}>
        <ContactField
          label={i18n.t("costs.columns.provider")}
          value={formData.providerId || null}
          onChange={(_event, newValue) => {
            handleInputChange("providerId")({
              target: { value: newValue ? newValue.SK : "" },
            })
          }}
        />
      </Grid>
    </>
  )
}

AccountingSection.propTypes = {
  formData: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
}

export default AccountingSection
